export enum UserRoles {
  student = 'student',
  teacher = 'teacher',
  viewer = 'viewer',
  admin = 'admin',
}
